import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import { PATH_DELIMITER, COMMUNITY_QNA_BODY_PATH } from '../../../../constant/Constant';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import { request } from '../../../ApiModule';
import { SET_GRID_DATA } from '../../../component/TableBoxModule';

const ACTION_SEARCH = COMMUNITY_QNA_BODY_PATH + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_ADD = COMMUNITY_QNA_BODY_PATH + PATH_DELIMITER + 'ACTION_ADD';
const ACTION_EDIT = COMMUNITY_QNA_BODY_PATH + PATH_DELIMITER + 'ACTION_EDIT';
const ACTION_REMOVE = COMMUNITY_QNA_BODY_PATH + PATH_DELIMITER + 'ACTION_REMOVE';
const ACTION_DETAIL = COMMUNITY_QNA_BODY_PATH + PATH_DELIMITER + 'ACTION_DETAIL';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionAdd = createAction(ACTION_ADD);
export const actionEdit = createAction(ACTION_EDIT);
export const actionRemove = createAction(ACTION_REMOVE);
export const actionDetail = createAction(ACTION_DETAIL);

export function* communityQnaSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_ADD, actionAddSaga);
    yield takeEvery(ACTION_EDIT, actionEditSaga);
    yield takeEvery(ACTION_REMOVE, actionRemoveSaga);
    yield takeEvery(ACTION_DETAIL, actionDetailSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/board/qnas',
        params,
        callback,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionAddSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/board/qnas',
        data: params,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(result.postingNo);
    }
}

function* actionEditSaga({ payload: { params, callback } }) {
    let editMethod = 'put';
    if (params.answerStatusCd && params.answerStatusCd == 'ANSWER') {
        editMethod = 'put';
    } else {
        editMethod = 'post';
    }
    const result = yield call(request, {
        method: editMethod,
        url: `/api/board/qnas/${params.postingNo}/answer`,
        data: params,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(params.postingNo);
    }
}

function* actionRemoveSaga({ payload: { params, callback } }) {
    let pno = parseInt(params.postingNo);

    const answerResult = yield call(request, {
        method: 'delete',
        url: `/api/board/qnas/${params.postingNo}/answer`,
        pno,
    });

    let questionResult;
    if (params.questionDelete) {
        const result = yield call(request, {
            method: 'delete',
            url: `/api/board/qnas/${params.postingNo}`,
            pno,
        });
        questionResult = result;
    }

    callback && callback(pno);
}

function* actionDetailSaga({ payload: { params, callback } }) {
    // TODO change to API
    let pno = parseInt(params.postingNo);
    const result = yield call(request, {
        method: 'get',
        url: `/api/board/qnas/${params.postingNo}`,
        pno,
    });

    const answerResult = yield call(request, {
        method: 'get',
        url: `/api/board/qnas/${params.postingNo}/answer`,
        pno,
    });

    //TODO answerResult
    if (NullCheckUtil.isNotEmpty(answerResult)) {
        result.answerPostingCtnt = answerResult.postingCtnt;
        result.answerFiles = answerResult.files;
        if (answerResult.userUniversityCd) {
            result.answerUserUniversityCd = answerResult.userUniversityCd;
        }
        result.answerUserNm = answerResult.userNm;
        result.answerRegDttm = answerResult.regDttm;
    }

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(result);
    }
}
